import { getConditionTypes } from '../../app/builder/condition/conditions'
import { ConditionType } from '../../app/builder/contexts/PatternTreeContext'

/**
 * Effective validity = the stored isValid flag AND the threshold re-check that
 * PatternListItem performs independently of it. A `changed *` condition with an
 * undefined threshold carries isValid === true but is still unsaveable, so
 * consumers filtering on the flag alone admit conditions the UI marks invalid.
 */
export const isConditionEffectivelyValid = (condition: ConditionType): boolean => {
  const inner = condition.condition
  if (!inner || inner.isValid === false) return false
  const typeMeta = getConditionTypes().find((type) => type.value === inner.conditionType)
  if (!typeMeta) return false
  if (typeMeta.hasThreshold && inner.threshold === undefined) return false
  return true
}
